import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addSchool } from 'slices/schoolSlice';
import { updateSchool } from 'slices/schoolSlice';
import { fetchSchools } from 'slices/schoolSlice';
import toast from 'react-hot-toast';
import { schoolSelector } from 'slices/schoolSlice';
import { setError } from 'slices/schoolSlice';
import { Select } from 'components/common/Select';
import { stateSelector } from 'slices/stateSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { fetchStates } from 'slices/stateSlice';
import { fetchZones } from 'slices/zoneSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';

const AddSchoolForm = ({ item, handleClose, callback, statusPerm }) => {
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, } = useForm();
  const dispatch = useDispatch();
  const { error, loader } = useSelector(schoolSelector);
  const { state: states } = useSelector(stateSelector);

  console.log(item, "item")

  useEffect(() => {
    // set simple fields
    setValue('name', item?.name || '');
    // setValue('status', (typeof item?.status === 'number') ? item.status : 1);

    // fetch states if still needed elsewhere
    dispatch(fetchStates());

    // set zone default for edit mode (both UI and form)
    if (item?.zone?.id && item?.zone?.name) {
      const zoneObj = { label: item.zone.name, value: item.zone.id };
      setFilterZone(zoneObj);          // UI selection for AsyncPaginate
      setValue('zone_id', item.zone.id); // react-hook-form value
    } else {
      setFilterZone(null);
      setValue('zone_id', null);
    }

    return () => {
      // cleanup on close/unmount
      dispatch(setError({}));
      setFilterZone(null);
      setValue('name', '');
      setValue('status', 1);
      setValue('zone_id', null);
    };
  }, [item]);



  // useEffect(() => {
  //   if (states?.length > 0) {
  //     if (item?.state?.id)
  //       setValue("state_id", item?.state?.id)
  //     else
  //       setValue("state_id", states ? states[0]?.id : null)
  //   }
  // }, [item, states])



  // #region States dropdown
  const [filterZone, setFilterZone] = useState({
    label: "",
    value: ""
  })

  // useEffect(() => {
  //   if (item?.zone?.name && item?.zone?.id) {
  //     setFilterZone({
  //       label: item?.zone?.name || "",
  //       value: item?.zone?.id || ""
  //     })
  //   } else {
  //     setFilterZone(null)
  //   }
  // }, [item?.zone])

  const filteredZonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchZones(
      page,
      { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue },
      true,
      true
    ));

    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchSchools())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    delete data.state_id;
    if (item?.id) {
      dispatch(updateSchool(data, item?.id, submitCallback));
    } else
      dispatch(addSchool(data, submitCallback));

  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>


        <div className="row-primary">
          <h2>School Name *</h2>

          <Controller
            name="name"
            control={control}
            render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='School Name' required {...field} />}

          />
        </div>


        <div className="row-primary">
          <h2>Select Zone *</h2>

          <Controller
            name="zone_id"
            control={control}
            rules={{ required: "Please select a zone" }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{ ...selectCustomStyles }}
                  value={filterZone || null}  // UI default
                  loadOptions={filteredZonesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setFilterZone(obj);
                    field.onChange(obj?.value); // form value
                  }}
                  additional={{ page: 1 }}
                />
                {errors?.zone_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.zone_id?.message} />
                  </div>
                }
              </div>
            }
          />

        </div>
        {/* {statusPerm &&
          <div className="row-primary flex-row align-items-center" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <Controller
              name="status"
              control={control}
              required
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CustomSwitch
                  labelText="active"
                  checked={field.value == 1 ? true : false}
                  handleChange={(checked) => field.onChange(checked ? 1 : 0)}

                />
              )}
            />
          </div>
        } */}
        {error?.errors?.name?.map((error) => (
          <div style={{ marginBottom: 10 }}>
            <ErrorMessage text={error} />
          </div>
        ))}

        <div className="Form-footer">
          <button type="button" className="Cancle_button" data-bs-dismiss="modal">Cancel</button>
          <SubmitButton
            loader={loader}
            btnText={item?.id ? "Update" : "Create"}
          />

        </div>
      </form>

    </div>
  )
}

const AddSchool = ({ item, onClose, callback, statusPerm }) => {
  return (
    <div className={`modal fade`} id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} School</h5>
            <button onClick={onClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            <AddSchoolForm item={item} handleClose={onClose} callback={callback} statusPerm={statusPerm} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddSchool
